export const SearchConf = {
  query: {
    keys: [
      {
        key: 'id_yacht.yacht_name',
        operator: '$containsi',
      },
      {
        key: 'operation_type',
        operator: '$containsi',
      },
      {
        key: 'id_department.name_department',
        operator: '$containsi',
      },
      {
        key: 'id_location.marina',
        operator: '$containsi',
      },
      {
        key: 'id_supplier.company_name',
        operator: '$containsi',
      },
    ],
  },
  placeholder: 'Search by department, yacht name, supplier or location',
  initialState: {
    value: '',
  },
};